/* global tns Drupal jQuery window cookiehub */

/**
 * Martela theme javascript
 *
 * @param {jQuery} $ jQuery object
 * @param {Drupal} Drupal Drupal object
 */
;(function ($, Drupal) {
  'use strict';

  $(document).ready(function () {
    martelaLangSelect();
    megamenuClasses();
    martelaMobilemenuIsOpen();
    martelaSearchBlock();
    sectionSubmenuClasses();
    martelaWrapTables();
    martelaBackgroundImageCarousel();
    martelaProductImageCarousel();
    martelaCasesFilter();
    martelaSliderCalculations();
    martelaShowForm();

    /**
     * Contact form jumper
     * Jumps to the selected contact form
     * @param {jQuery} el jQuery object of the select element
     */
    function martelaContactFormJumper(el) {
      el.off('change').on('change', function () {
        var url_form = el.find(':selected').data('url');
        var win_form = window.open(url_form, '_self');
        win_form.focus();
      });
    }

    let contactFormJumpMenu = $('.contact-forms .js-viewsJumpMenu');
    martelaContactFormJumper(contactFormJumpMenu);
    let contactFormJumpMenuUs = $('.view-mar-contact-us-office-listing .js-viewsJumpMenu');
    martelaContactFormJumper(contactFormJumpMenuUs);
  });

  /* Wrap tables */
  function martelaWrapTables() {
    let tables = $('table');
    if (tables.length > 0) {
      tables.wrap('<div class="table-wrapper"></div>');
    }
  }

  /* Language switcher */
  function martelaLangSelect() {
    var langSelect = $('.lang-select');
    var langSelectButton = $('<button class="language-toggle-button" id="language-toggle-button" type="button">'
      + '<svg class="icon icon-globe"><use xlink:href="#icon-globe" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>'
      + '<span class="language-toggle-text" lang="en" xml:lang="en">Choose country</span></button>');
    if (langSelect.length > 0) {
      // Wrap language menu
      langSelect.wrap('<div class="language-toggle-wrapper"><div class="language-list-wrapper"></div></div>');
      // Include a toggle button
      $('.language-toggle-wrapper').prepend(langSelectButton);
      // Toggle classes on click
      langSelectButton.click(function () {
        $(this).toggleClass('selection-open');
        $('.language-list-wrapper').toggleClass('visible');
      });
    }
  }

  /* Megamenu classes */
  function megamenuClasses() {
    // Add classes to certain links' parent elements
    var menuBase = $('.region-navigation .block-superfish');
    var megamenuLink = menuBase.find('li.sf-depth-1 a.megamenu');
    var hugeLink = menuBase.find('li a.huge-link');
    var spanColumnsLink = menuBase.find('li a.span-all-columns');

    if (megamenuLink.length > 0) {
      megamenuLink.each(function () {
        $(this).parent('li').addClass('megamenu-item');
      });
    }
    if (hugeLink.length > 0) {
      hugeLink.each(function () {
        $(this).parent('li').addClass('huge-link-item');
      });
    }
    if (spanColumnsLink.length > 0) {
      spanColumnsLink.each(function () {
        $(this).parent('li').addClass('span-all-columns-item');
      });
    }
  }

  /* Section starting page submenu classes */
  function sectionSubmenuClasses() {
    if ($('.section-2nd-level-menu').length > 0) {
      // Find the first active menu link and add a class to it
      var firstActiveLink = $('.section-2nd-level-menu ul.menu li a.is-active').first();
      firstActiveLink.addClass('first-active');
    }
  }

  /* Mobile menu open class */
  function martelaMobilemenuIsOpen() {
    var mobilemenuToggle = $('.region-navigation .mobilemenu .sf-accordion-toggle a');
    // Toggle class on body when mobile menu toggle is clicked
    if (mobilemenuToggle.length > 0) {
      mobilemenuToggle.on('click', function () {
        $('body').toggleClass('mobilemenu-is-open');
      });
    }
  }

  /* Search block */
  function martelaSearchBlock() {
    var regionNavigation = $('.region-navigation .addsearch-block');
    var searchbuttonToggle = regionNavigation.find('.form-enable-button');
    var searchForm = regionNavigation.find('form');
    var searchbuttonSubmit = searchForm.find('.form-submit');
    var headerBlockFieldset = regionNavigation.find('fieldset');
    var headerSearchWidget = $('#ui-id-1');

    // Toggle class on body when mobile menu toggle is clicked
    if (searchbuttonToggle.length > 0) {
      headerBlockFieldset.remove();
      searchbuttonToggle.on('click', function () {
        searchForm.toggleClass('show');
      });

      searchbuttonSubmit.on('click', function () {
        searchForm.removeClass('show');
        headerSearchWidget.css('display', 'none');
      });
      searchForm.keyup(function (e) {
        if (e.keyCode === 13) {
          searchForm.removeClass('show');
          headerSearchWidget.css('display', 'none');
        }
      });
    }
  }

  /* Cases page filter */
  function martelaCasesFilter() {
    var allCasesForm = $('.all-cases #views-exposed-form-cases-block-all-cases');
    var allCasesSelect = $('.select2-widget', allCasesForm);
    var allCasesSubmit = $('#edit-actions', allCasesForm);

    allCasesSubmit.css({ display: 'none', visibility: 'hidden' });

    allCasesSelect.change(function () {
      allCasesForm.submit();
    });
  }

  /**
   * Frontpage background carousel
   * Powered by Tiny Slider
   */
  function martelaBackgroundImageCarousel() {
    var carouselContentSelector = '.carousel-content';
    var carouselContainer = carouselContentSelector + ' .view-content';
    var carouselImagesSelector = '.carousel-images';
    var carouselContent = $(carouselContentSelector);
    var carouselImages = $(carouselImagesSelector);

    if (carouselContent.length && carouselImages.length) {
      if (typeof tns !== 'undefined') {
        var slider = tns({
          autoplay: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: false,
          autoplayTimeout: 10000,
          container: carouselContainer,
          items: 1,
          slideBy: 1,
          speed: 200,
          nav: false,
          onInit: function () {
            // When carousel is started
            // - set first item as active
            // - set other items inactive
            $('.views-row', carouselImages).not(':first').addClass('inactive').css('opacity', 0);
            $('.views-row', carouselImages).first().addClass('active').css('opacity', 1);
          },
        });
        // Bind function to indexChanged event
        slider.events.on('indexChanged', customizedFunction);
      }
    }
  }

  /**
   * When carousel index is changed
   * Notice: the index will change TWICE when carousel loops around
   */
  var customizedFunction = function (info, eventName) {
    var carouselImagesSelector = '.carousel-images';
    var carouselImages = $(carouselImagesSelector);

    // Set active slide as inactive and set its opacity to 0
    $('.views-row.active', carouselImages)
      .toggleClass('active inactive')
      .animate({ opacity: 0 }, 0, function () {
        // After that set the displayed slide as active and set its opacity to 1
        $('.views-row', carouselImages)
          .eq(info.displayIndex - 1)
          .toggleClass('active inactive')
          .animate({
            opacity: 1,
          }, 0);
      });
  };

  /**
   * Product image carousel
   * Powered by Tiny Slider
   */
  function martelaProductImageCarousel() {
    var carouselContainer = ' .product-image-gallery';

    if ($(carouselContainer).length) {
      if (typeof tns !== 'undefined') {
        tns({
          autoplay: false,
          autoplayButtonOutput: false,
          autoplayHoverPause: false,
          autoplayTimeout: 10000,
          container: carouselContainer,
          items: 1,
          nav: true,
          navPosition: 'bottom',
          slideBy: 1,
          speed: 200,
        });
      }
    }
  }

  // COOKIE CHECK
  if (window.cookiehub) {
    $(window).on('load', function () {
      youtubeCookieCheck();
    });
  }

  // Create mutation observer to observe video link visibility which is toggled by cookiehub based on the user's cookie category selection.
  var observer = new MutationObserver(() => youtubeCookieCheck());

  var target = $('.video-link');
  target.each(function () {
    observer.observe($(this)[0], { attributes: true });
  });

  // Check if visitor has checked analytics in CookieHub and show/hide iframe block
  function youtubeCookieCheck() {
    let cookieHubVideoWrapper = $('.video-thumbnail .cookiehub-actions-wrapper');
    if (window.cookiehub.hasConsented('analytics')) {
      cookieHubVideoWrapper.addClass('hidden');
    } else {
      cookieHubVideoWrapper.removeClass('hidden');
    }
  }

  /**
   * Martela Drupal object
   */
  let martelaDrupal = {};
  /* Open stuff in a modal */
  martelaDrupal.martelaOpenModal = context => {
    if (typeof $.magnificPopup !== 'undefined') {
      // Video modal
      let videoLink = $('.video-link');
      if (videoLink.length > 0) {
        videoLink.magnificPopup({
          type: 'iframe',
        });
      }
      // Image gallery modal
      let imageGallery = $('.image-gallery');
      if (imageGallery.length > 0 && $('.gallery-image-link').length > 0) {
        imageGallery.each(function () {
          // the containers for all your galleries
          $(this).magnificPopup({
            delegate: 'a.gallery-image-link', // the selector for gallery item
            type: 'image', gallery: {
              enabled: true,
            },
          });
        });
      }
      // Inline modal
      let marOpenModal = $('.mar-open-modal');
      if (marOpenModal.length > 0) {
        marOpenModal.each(function () {
          $(this).magnificPopup({
            items: {
              src: $(this).next('.mfp-hide'), midClick: true, type: 'inline',
            },
          });
        });
      }
    }
  };
  /* Add class to body when megamenu is open */
  martelaDrupal.martelaMegaMenuIsOpen = context => {
    // Find menu links with megamenu class and their parent element
    var $megamenuParents = $('.region-navigation .sf-horizontal a.megamenu').parent('li');

    // Bail out early
    if (!$megamenuParents.length) {
      return null;
    }

    var $body = $('body');
    var observedClass = 'sfHover';

    // Binds a class name to a predicate for filtering element arrays
    var filterElementsByClass = className => element => element.classList.contains(className);

    // A predicate for filtering away null values from arrays
    var notNull = value => value !== null;

    // A mapping function used to map applicable mutation objects to DOM elements
    var mutationToElement = mutation => mutation.attributeName === 'class' ? mutation.target : null;

    // Handles mutation batches
    var handleMutations = function (elements) {
      var filtered = elements.filter(filterElementsByClass(observedClass));
      var fn = filtered.length ? 'addClass' : 'removeClass';
      $body[fn]('menu-is-open');
    };

    // Observes element mutations and batches them
    var observer = new MutationObserver(function (mutations) {
      var mutatedElements = mutations.map(mutationToElement).filter(notNull);
      window.requestAnimationFrame(() => handleMutations(mutatedElements));
    });

    // Attach observer
    $megamenuParents.each(function () {
      observer.observe(this, { attributes: true });
    });
  };

  /**
   * Attach functions to Drupal behaviors
   * @see https://www.drupal.org/docs/drupal-apis/javascript-api/javascript-api-overview
   *
   * @inheritDoc
   * @param {Document|HTMLElement} context The context in which to attach the behavior
   * @param {?Object} settings An object containing settings for the current context
   */
  Drupal.behaviors.attach = (context, settings) => {
    martelaDrupal.martelaOpenModal(context);
    martelaDrupal.martelaMegaMenuIsOpen(context);
  };

  // Functions for calculating logarithmic scale for sliders

  /**
   * Calculate logarithmic scale for slider
   *
   * @param {number} val Slider value
   * @param {number} min Minimum value
   * @param {number} max Maximum value
   * @returns {number} Calculated value
   */
  function logPosition(val, min, max) {
    var minV = Math.log(min);
    var maxV = Math.log(max);
    var scale = (maxV - minV) / (max - min);
    return (Math.log(val) - minV) / scale + min;
  }

  /**
   * Calculate exponential scale for slider
   * @param {number} val Slider value
   * @param {number} min Minimum value
   * @param {number} max Maximum value
   * @returns {number} Exponential value
   */
  function exp(val, min, max) {
    var minV = Math.log(min);
    var maxV = Math.log(max);
    var scale = (maxV - minV) / (max - min);
    return Math.exp(minV + scale * (val - min));
  }

  function martelaSliderCalculations() {
    // Create a slider for users
    var userHandle = $('#slider-value-users');
    var uStartValue = 30;
    var uMinValue = 5;
    var uMaxValue = 5000;

    // Create a slider for area
    var aStartValue = 300;
    let sliderValueArea = $('#slider-value-area');
    sliderValueArea.text(aStartValue);

    /**
     * Handle user slider
     * @param {string} value Slider value
     */
    function handleUserSlider(value) {
      sliderValueArea.text(value * 10);
    }

    // Slider for users space
    $('#spaceUsers').slider({
      value: Number(logPosition(uStartValue, uMinValue, uMaxValue).toFixed(0)),
      min: uMinValue,
      max: uMaxValue,
      orientation: 'vertical',
      create: () => userHandle.text(uStartValue),
      slide: (event, ui) => userHandle.text(Number(exp(ui.value, uMinValue, uMaxValue).toFixed(0))),
      change: (event, ui) => {
        handleUserSlider(Number(exp(ui.value, uMinValue, uMaxValue)).toFixed(0));
        handleSliderCalculations();
      },
    });

    // Increment and decrement buttons for area slider

    $('.increment').on('click', function () {
      var current = sliderValueArea.text();
      var newValue = Number(current) + 1;
      handleSliderCalculations();
      return sliderValueArea.text(newValue);
    });
    $('.decrement').on('click', function () {
      var current = sliderValueArea.text();
      var newValue = Number(current) - 1;
      handleSliderCalculations();
      return sliderValueArea.text(newValue);
    });

    // Simple calculations on separated chained functions
    handleSliderCalculations();

    // Also on currency dropdown
    $('#currency-dropdown').change(() => handleSliderCalculations());
    sliderValueArea.change(() => handleSliderCalculations());
  }

  /**
   * Get currency multiplier based on dropdown value
   * @param {string} dropdown
   * @return {number}
   */
  function getCurrencyMultiplier(dropdown) {
    switch (dropdown) {
      case 'eur':
        return 40;
      default:
        return 400;
    }
  }

  /**
   * Get currency marker based on value
   * @param {string} value
   * @return {string}
   */
  function getCurrencyMarker(value) {
    switch (value) {
      case 'eur':
        return '€';
      default:
        return 'KR';
    }
  }

  /**
   * Calculate value based on space value and currency
   *
   * @param {number} spaceValue Space value
   * @param {number} currency Currency multiplier
   * @returns {number}
   */
  function calculateValue(spaceValue, currency) {
    return Math.round((spaceValue / 10) * currency);
  }

  /**
   * Handle calculations for the slider
   */
  function handleSliderCalculations() {
    // Get lang from url
    var pathname = window.location.pathname;
    var lang = pathname.split('/');
    var currency1 = currencyChoice(lang[1]);
    var currencyMultiplier = getCurrencyMultiplier(currency1);
    var currency = getCurrencyMarker(currency1);
    var spaceValue = Number($('#slider-value-area').text());
    var calculatorPrice = calculateValue(spaceValue, currencyMultiplier) + ' ';
    var currencyValue = currency + Drupal.t('/kk');

    let valueBlock = $('.value-block');
    valueBlock.find('.value').text(calculatorPrice);
    valueBlock.find('.valuecurrency').text(currencyValue);

    // Set global variables for sliders
    window.sliderPrice = {
      value: calculatorPrice,
    };
    window.sliderPeople = {
      value: Number(
        exp(
          $('#spaceUsers').slider('option', 'value'),
          5,
          5000
        ).toFixed(0)
      ),
    };
    window.sliderArea = {
      value: spaceValue,
    };
  }

  function martelaShowForm() {
    $('.add-to-form').click(function (el) {
      el.preventDefault();
      el.parents().find('.calculation-sliders').css('display', 'none');
      $('.module-inner-row').find('#lomake-id').toggle();
      $('html, body').animate({ scrollTop: el.offset().top }, 'slow');
    });
  }

  /**
   * Currency choice from language
   *
   * @param {string} lang
   * @return {string}
   */
  function currencyChoice(lang) {
    switch (lang) {
      case 'sv':
        return 'sek';
      case 'no':
        return 'nok';
      default:
        return 'eur';
    }
  }

})(jQuery, Drupal);

document.addEventListener('DOMContentLoaded', function () {
  // Brevo custom event code
  var sibSubmitButton = document.evaluate(
    '//*[@id=\'sib-form\']/div/div/button',
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null
  ).singleNodeValue;
  if (sibSubmitButton) {
    sibSubmitButton.addEventListener(
      'click',
      function () {
        window.sendinblue.track(
          'trackFormSubmit',
          { email: document.getElementById('EMAIL').value },
          { id: 'trackFormSubmit', data: { url: window.location.href } }
        );
      }
    );
  }
});
